import { FC, useState, useEffect } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { BaseTreeExplorer } from 'components/BaseTreeExplorer';
import { ClickAwayListener, Input, IconButton, FormGroup, Box } from '@material-ui/core';
import SubdirectoryArrowLeftIcon from '@material-ui/icons/SubdirectoryArrowLeft';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import { observer } from 'mobx-react-lite';
import { BaseProps } from './types';

export const BaseNavigation: FC<BaseProps> = observer((type) => {
  const classes = useStyles();
  const {
    baseTreeExplorerStore: {
      navigationHistory: { base },
      setBase,
      setCurrentHistory,
      navigateToRoot,
      navigateToPreviosLevel,
      setSelected,
    },
  } = useStore();
  const [openBaseExplorer, setOpenBaseExplorer] = useState<boolean>(false);

  const toggleBaseExplorer = () => {
    setOpenBaseExplorer((prev) => !prev);
    setCurrentHistory('navigation');
  };

  useEffect(() => {
    setBase('all');
    setSelected('all');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseBaseExplorer = () => setOpenBaseExplorer(false);
  const handleOpenBaseExplorer = () => {
    setOpenBaseExplorer(true);
    setCurrentHistory('navigation');
  };

  return (
    <ClickAwayListener onClickAway={handleCloseBaseExplorer}>
      <div className={classes.block}>
        <IconButton
          className={classes.iconBtn}
          disabled={base === '/'}
          aria-label='home'
          size='small'
          onClick={() => navigateToRoot()}
        >
          <HomeWorkIcon />
        </IconButton>
        <IconButton
          className={classes.iconBtn}
          disabled={base === '/'}
          aria-label='back'
          size='small'
          onClick={() => navigateToPreviosLevel()}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box style={{ width: '100%' }}>
          <div className={classes.block} onDoubleClick={handleCloseBaseExplorer} onMouseLeave={handleCloseBaseExplorer}>
            <Input
              className={classes.inputWide}
              placeholder='Base'
              value={base}
              onClick={toggleBaseExplorer}
              onMouseEnter={handleOpenBaseExplorer}
              endAdornment={type.type !== 'Add New Group' && <SubdirectoryArrowLeftIcon style={{ color: 'grey' }} />}
            />
            {type.type !== 'Add New Group' && openBaseExplorer ? (
              <FormGroup className={classes.dropdown}>
                <BaseTreeExplorer />
              </FormGroup>
            ) : null}
          </div>
        </Box>
      </div>
    </ClickAwayListener>
  );
});
